//the semi-colon before function invocation is a safety net against concatenated
//scripts and/or other plugins which may not be closed properly.
;(function( $, window, document, undefined ) {

	"use strict";

	var pluginName = 'mobileNav',
		defaults = {
		};

	function Plugin( element, options, id )
	{
		this.id = id;
		this.element = element;
		this.settings = $.extend( {}, defaults, options );
		this._defaults = defaults;
		this._name = pluginName;

		this.init();
	}

	$.extend( Plugin.prototype, {

		init: function()
		{
            let _ = this;
            
            $('#navBtn').on('click', function(){
                $(this).toggleClass('mobile-active');
                $('body').toggleClass('mobile-nav-active');
                $('.mobile-navigation-container').toggleClass('nav-active');
			});
			
			$('.mobile-navigation-container .menu-item').on('click', 'i', function(){
				let value = $(this).data('name');
				let em = $('.mobile-navigation-container').find('#'+value);

				$(em).addClass('is-active');
			});

			_.cloneNavigation();
			_.windowSizing();
			_.closeSubMenu();

			$('.mobile-navigation-container').on('click', '.icon-close', function(){
				_.removeBodyClasses();
			});
		},

        cloneNavigation: function()
        {
            $('.mobile-navigation-container ul.menu > .menu-item-has-children').each(function(index) {
				let elem = $(this).find('ul.sub-menu:first');
				$(elem).attr('id', 'subMenu-'+index);
				$('.mobile-navigation-container nav').append(elem);

				let newElem = `
					<li class="menu-item menu-item--back">
						<i class="icon-arrow-right"></i> Go Back
					</li>`;
				$(elem).prepend(newElem);

				$(this).find('i').attr('data-name', 'subMenu-'+index);
            });
		},

		closeSubMenu: function()
		{
			$('.menu-item--back').on('click', function(){
				$('.sub-menu.is-active').removeClass('is-active');
			});
		},

		removeBodyClasses: function()
		{
			$('.mobile-active').removeClass('mobile-active');
            $('body').removeClass('mobile-nav-active');
            $('.mobile-navigation-container').removeClass('nav-active');
			$('.sub-menu.is-active').removeClass('is-active');
		},
		
		windowSizing: function()
		{
			let _ = this;

			$(window).resize(function(e) {
				if ($(window).outerWidth() > 1070) {
					_.removeBodyClasses();
				}
			});
		}

	} );

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[ pluginName ] = function( options ) {
		return this.each( function() {
			if ( !$.data( this, "plugin_" + pluginName ) ) {
				$.data( this, "plugin_" +
					pluginName, new Plugin( this, options ) );
			}
		} );
	};
		
})( jQuery, window, document );